export default {
feedback: {
  title: "Maklum balas",
  placeholder: "Tinggalkan mesej ({ contentLen }/1000 aksara)",
  error: "Ini adalah mesej ralat",
  uploadLimit: "Had muat naik gambar dan video",
  send: "Hantar",
  tipTitle: "Bantu kami meningkatkan pengalaman anda",
  desc1: "Anda boleh menghantar sebarang soalan, dan jika diterima, anda akan menerima hadiah kejutan.",
  desc2: "Jika tidak mudah melalui laman web, anda juga boleh menghantarnya melalui e-mel."
}
};
